export * from './resend-email-verification.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader?keepUrl=true!./node_modules/tslint-loader!./src/resend-email-verification/index.ts